var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.794 8.95707C59.6791 8.1319 59.0854 7.45314 58.2829 7.23005L32.5602 0.076549C32.1935 -0.0255163 31.8061 -0.0255163 31.4391 0.076549L5.71641 7.23005C4.91383 7.45314 4.32013 8.13163 4.20523 8.95707C4.05604 10.0299 0.652466 35.3778 9.3824 47.9876C18.102 60.5823 30.9653 63.8099 31.5086 63.9413C31.67 63.9803 31.8345 63.9996 31.9996 63.9996C32.1647 63.9996 32.3293 63.9801 32.4907 63.9413C33.0342 63.8099 45.8975 60.5823 54.6169 47.9876C63.3468 35.3781 59.9432 10.0302 59.794 8.95707ZM48.5875 23.7554L31.042 41.3009C30.6337 41.7092 30.0983 41.9136 29.5632 41.9136C29.028 41.9136 28.4926 41.7095 28.0843 41.3009L17.2361 30.4527C16.8438 30.0606 16.6235 29.5285 16.6235 28.9739C16.6235 28.4192 16.844 27.8871 17.2361 27.495L19.3901 25.3411C20.2069 24.5245 21.5312 24.5243 22.3478 25.3411L29.5632 32.5565L43.4759 18.6435C43.8679 18.2512 44.4 18.0308 44.9547 18.0308C45.5093 18.0308 46.0414 18.2512 46.4335 18.6435L48.5875 20.7975C49.4043 21.6143 49.4043 22.9386 48.5875 23.7554Z",
    fill: "url(#paint0_linear_383_10621)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_10621",
    x1: 3.42871,
    y1: 31.9998,
    x2: 60.5706,
    y2: 31.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigShield);
export default __webpack_public_path__ + "static/media/bigShield.6e0b23857f7d722c16c63d789f26e6e4.svg";
export { ForwardRef as ReactComponent };